const keys = {
    googleKey: "AIzaSyDI7_QYJHcQo21uoCSIVz48MyCOpkv97zg",
    cloudName: "dgupilxum",
    uploadPreset: "l1c4hxcn",
};

export default {
    keys
}